import {
    Box,
    IconButton,
    List,
    ListItem,
    Tooltip,
    Typography,
} from '@mui/material'
import { ActionsDropdown } from '../Components/ActionsDropdown'
import GeoJSONTypeData from '../../Common/GeoJsonTypeData'
import URLTypeData from '../../Common/URLTypeData'
import {
    isAlaramSatus,
    isDateTime,
    isEntity,
    isEntityJson,
    isFile,
    isGeoFence,
    isGPS,
    isJson,
    isPDFBase64,
    isURL,
} from '../../../utils/AttributeUtils'
import CertificateViewer from '../../Common/Base64ToPDF'
import EntityTypeData from '../../Common/EntityTypeData'
import EntityJsonTypeData from '../../Common/EntityJsonTypeData'
import EntityFileTypeData from '../../Common/EntityFileTypeData'
import DatetimeTypeData from '../../Common/DatetimeTypeData'
import EntityTableCell from '../../Common/EntityTableCell'
import ViewEntityBox from '../../Common/ViewEntityBox'
import ViewEntityRow from '../../Common/ViewEntityRow'
import BusinessRuleSetsView from './BusinessRuleSetsView/BusinessRuleSetsView'
import TruncatedText from '../../Common/TruncatedText'
import { CloseOutlined, Info } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
    Applications,
    DeviceManagerStatusToUI,
    DEVICE_MANAGER_REGISTERED,
    EntityInstanceTypes,
    EntityStatus,
    EntityStatusBEtoUI,
    publicShipmentView,
    ShipmentAttributes,
    TemplatePermissionMode,
    URLSearchParamsKeys,
    USER_ROLES,
    UserPermissions,
} from '../../../constants/constants'
import { useMemo, useState, useRef, useEffect, useCallback } from 'react'
import RelationModification from './RelationModification'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import { useSnackbar } from 'notistack'
import {
    modifingItemInRelation,
    postUserAction,
} from '../../../services/entityServices'
import { getEntityViewDetails } from '../../../redux/slices/entityViewSlice'
import ConfirmationDialog from '../../Common/ConfirmationDialog'
import EntityInstance from '../../Entity/EntityInstance'
import AlarmStatusTypeData from '../Components/AlarmStatusTypeData'
import { IApplicationSettingsType } from '../../Applications/interfaces'
import { InTransitSettingsType } from '../../Applications/Intransit/interfaces'
import { isStringifiedNull } from '../../../utils/StringUtils'
import PreviewColumnsArrangement from '../Components/PreviewColumnsArrangement'
import {
    isAttributeTypeStatic,
    isCreationDateTime,
} from '../../../utils/MiscellaneousUtils'
import { findEntityById, isCompletedDevice } from '../../../utils/EntityUtils'
import { EntityType } from '../../DTStudio/interfaces'
interface IDetailsViewProps {
    applicationSettings: IApplicationSettingsType
}
const DetailsView: React.FC<IDetailsViewProps> = (props) => {
    const { applicationSettings } = props
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const dispatch = useAppDispatch()
    const refetchTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const [searchParams, setSearchParams] = useSearchParams()
    const [viewEntityData, setViewEntityData] = useState<{
        templateName: string
        templateId: string
        entityId: string
        orgId: string
    }>({
        templateName: '',
        templateId: '',
        entityId: '',
        orgId: '',
    })
    const [openEntityInstance, setOpenEntityInstance] = useState(false)
    const [userActionValue, setUserActionValue] = useState('')
    const [isOpenUserActionSubmit, setIsOpenUserActionSubmit] = useState(false)
    const [
        isOpenDeleteConfirmForRelationEntity,
        setIsOpenDeleteConfirmForRelationEntity,
    ] = useState<boolean>(false)
    const [deletingRelationItem, setDeletingRelationItem] = useState<any>()

    const permissions = useAppSelector((state) => state.org.permissions)
    const loggedInOrgId = useAppSelector((state) => state.org.org?.id)
    const entityData = useAppSelector(
        (state) => state.entityInstanceView.entityData,
    )
    const {
        selfEntityAttributeData,
        relatedEntitiesResponse,
        entityParentRelationsData,
        entityRelationsData,
        action,
        userActionsData,
        templateName,
        ruleSets,
        organizationId,
        status,
    } = entityData
    const entityTemplateRelations = useAppSelector(
        (state) => state.entityInstanceView.entityTemplateRelations,
    )
    const columnsOrder = useAppSelector(
        (state) => state.entityInstanceView.columnsOrder,
    )
    const navList = useAppSelector((state) => state.nav.navList)
    const isGuestUser =
        useAppSelector((state) => state.searchParams.isGuestUser) === 'true'
    const guestUserPreferredUnit = useAppSelector(
        (state) => state.entityInstanceView.guestUserPreferredUnit,
    )

    const publicSearchTemplateId = useAppSelector(
        (state) => state.searchParams.templateId,
    )
    const publicSearchOrgId = useAppSelector(
        (state) => state.searchParams.orgId,
    )
    const publicSearchViewId = useAppSelector(
        (state) => state.searchParams.instanceId,
    )
    const isPublicShipmentPreView =
        useAppSelector((state) => state.searchParams.publicShipmentView) ===
        publicShipmentView.SHIPMENT_PREVIEW
    const userRole = useAppSelector((state) => state.user.user?.role) ?? ''
    const orgId = isPublicShipmentPreView
        ? publicSearchOrgId || ''
        : loggedInOrgId || ''
    const entityTemplateId =
        (isPublicShipmentPreView
            ? publicSearchTemplateId
            : searchParams.get(URLSearchParamsKeys.templateId)) || ''
    const viewID =
        (isPublicShipmentPreView
            ? publicSearchViewId
            : searchParams.get(URLSearchParamsKeys.instanceId)) || ''

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const applicationId = queryParams.get('applicationId') || ''
    const isDeviceManagerApp = applicationId === Applications.deviceManager.id

    //even if the user is guest user we need to show the shipement view
    const isColdChainView = useMemo(
        () => applicationId === Applications.inTransit.id || isGuestUser,
        [applicationId, isGuestUser],
    )

    const isFacilityMonitoringView = useMemo(
        () => applicationId === Applications.facilityMonitoring.id,
        [applicationId],
    )

    const inTransitSettings = useMemo(() => {
        let inTransitSettings = {} as InTransitSettingsType
        let isIntransitShipmentPreview = false
        if (isColdChainView) {
            isIntransitShipmentPreview =
                (applicationSettings as InTransitSettingsType)
                    .shipmentEntityTemplateId === entityTemplateId
            if (isIntransitShipmentPreview) {
                inTransitSettings = applicationSettings as InTransitSettingsType
            }
        }

        return inTransitSettings
    }, [applicationSettings, isColdChainView, entityTemplateId])

    const templateData = useMemo(
        () =>
            (entityTemplateId &&
                findEntityById(navList, entityTemplateId)?.entity) ||
            ({} as EntityType),
        [entityTemplateId, navList],
    )
    // if template device:writer permission is true. then that template is consider as "device" template. we need to give writer permission to superAdimn or deviceManger only
    const isDeviceTemplate = useMemo(() => {
        return !!templateData?.permissions?.writer?.device
    }, [templateData])

    const isSuperAdmin = permissions?.includes(UserPermissions.ORG_ADMIN)
    const isDeviceManager = useMemo(
        () =>
            userRole === USER_ROLES.DEVICE_MANAGER ||
            permissions?.includes(UserPermissions.ORG_ADMIN),
        [permissions, userRole],
    )
    const hasDeviceWritePermission = useMemo(
        () =>
            permissions?.includes(UserPermissions.DEVICE_WRITER) ||
            permissions?.includes(UserPermissions.ORG_ADMIN) ||
            userRole === USER_ROLES.DEVICE_MANAGER ||
            userRole === USER_ROLES.SYSTEM_ADMIN,
        [permissions, userRole],
    )
    const hasEditPermission = isDeviceTemplate
        ? hasDeviceWritePermission &&
          (action === TemplatePermissionMode.WRITE ||
              action === TemplatePermissionMode.READ_WRITE)
        : (action === TemplatePermissionMode.WRITE ||
              action === TemplatePermissionMode.READ_WRITE) &&
          permissions.includes(UserPermissions.ENTITY_WRITER) &&
          !isGuestUser

    const hasChildRelationEditPermission = isDeviceTemplate
        ? isDeviceManager
        : (action === TemplatePermissionMode.WRITE ||
              action === TemplatePermissionMode.READ_WRITE) &&
          permissions.includes(UserPermissions.ENTITY_WRITER) &&
          !isGuestUser

    // TODO: => optimize the list
    const detailsAttributes = useMemo(() => {
        if (!selfEntityAttributeData) {
            return []
        }

        // map selfEntityAttributeData (already in desired format)
        const selfAttributes = selfEntityAttributeData.attributes ?? []

        let relationAttributes: any[] = []
        let searatesAttributes: any[] = []
        let deviceAttributes: any[] = []

        if (isColdChainView) {
            // map entityRelationsData to the same format as selfAttributes
            // TODO: => optimize, here we are reading trip number from the entityRelationsData with "Device" name. it's kind of hard coded. need to find trip number by "intransitSettings?.deviceEntityTemplateId"
            relationAttributes =
                entityRelationsData?.map((rel) => ({
                    id: rel.relationId,
                    name: rel.name,
                    value: rel.label,
                })) ?? []

            //maritime tracking relation attributes. for "containerNumber", "sealine" and "vessels"(it's coming as JSON need to get names)
            const searatesRelationName =
                entityTemplateRelations.find(
                    (relation) =>
                        relation.childEntity ===
                        inTransitSettings?.searatesEntityTemplateId,
                )?.relationName || ''

            const deviceRelationName =
                entityTemplateRelations.find(
                    (relation) =>
                        relation.childEntity ===
                        inTransitSettings?.deviceEntityTemplateId,
                )?.relationName || ''

            searatesAttributes =
                relatedEntitiesResponse?.relations?.[
                    searatesRelationName
                ]?.[0]?.attributes
                    ?.filter(
                        (i) =>
                            i.id ===
                                ShipmentAttributes.ContainerNumberAttributeId ||
                            i.id === ShipmentAttributes.SealineAttributeId ||
                            i.id === ShipmentAttributes.VesselsAttributeId,
                    )
                    .map((i) => {
                        if (i.id === ShipmentAttributes.VesselsAttributeId) {
                            return {
                                ...i,
                                dataType: 'string',
                                value:
                                    i.value?.length &&
                                    !isStringifiedNull(i.value) &&
                                    Array.isArray(i.value)
                                        ? i.value.map((v: any) => v.name)
                                        : '',
                            }
                        } else return i
                    }) ?? []

            deviceAttributes =
                relatedEntitiesResponse?.relations?.[
                    deviceRelationName
                ]?.[0]?.attributes?.filter(
                    (i) => i.id === ShipmentAttributes.BatteryPercentage,
                ) ?? []
        }

        // combine all attributes
        const allAttributes = [
            ...selfAttributes,
            ...relationAttributes,
            ...searatesAttributes,
            ...deviceAttributes,
        ]

        // create a Map for quick lookup
        const attributeMap = new Map(
            allAttributes.map((attr) => [attr.id, attr]),
        )

        //columns order
        const isDeviceManagerView =
            applicationId === Applications.deviceManager.id
        const filteredColumnsOrder = isDeviceManagerView
            ? columnsOrder.map((col) => {
                  if (col.attributeName === 'entityStatus') {
                      return {
                          ...col,
                          columnName: 'Device Status',
                          name: 'Device Status',
                      }
                  } else {
                      return col
                  }
              })
            : columnsOrder.filter((col) => col.attributeName !== 'entityStatus')

        const updateColumnOrder = filteredColumnsOrder.filter((i) =>
            isColdChainView
                ? i.selected
                : i.selected && i.attributeType === 'self',
        )

        // filter and order based on coldChainDetails
        return updateColumnOrder.map((c) => {
            const attribute = attributeMap.get(c.id)
            if (!attribute) return c
            return { ...attribute, name: t(c.name) || t(attribute.name) }
        })
    }, [
        selfEntityAttributeData,
        relatedEntitiesResponse,
        entityRelationsData,
        inTransitSettings,
        entityTemplateRelations,
        columnsOrder,
        t,
        isColdChainView,
        applicationId,
    ])

    //refetch the details
    const refetch = useCallback(() => {
        dispatch(
            getEntityViewDetails({
                orgId,
                recordId: viewID,
                entityTemplateId,
                isGuestUser,
                guestUserPreferredUnit,
            }),
        )
    }, [
        dispatch,
        orgId,
        viewID,
        entityTemplateId,
        isGuestUser,
        guestUserPreferredUnit,
    ])

    //edit entity
    const onClickEditIcon = () => {
        setOpenEntityInstance(true)
        setViewEntityData({
            templateName,
            templateId: entityTemplateId,
            entityId: viewID,
            orgId: organizationId,
        })
    }

    const handleCloseFields = () => {
        setOpenEntityInstance(false)
        setViewEntityData({
            templateName: '',
            templateId: '',
            entityId: '',
            orgId: '',
        })
        refetch()
    }

    //action modification functions
    const onClickUserActions = (action: any) => {
        setUserActionValue(action.target.value)
        setIsOpenUserActionSubmit(true)
    }

    const onSubmitUserActions = useCallback(async () => {
        dispatch(updateLoader(true))
        const userActionPayload = {
            entityId: viewID,
            action: userActionValue,
            orgId,
        }
        const REFETCH_DELAY_MS = 10000
        const REFETCH_DELAY_SECONDS = REFETCH_DELAY_MS / 1000

        try {
            await postUserAction(userActionPayload)
            dispatch(updateLoader(false))
            setIsOpenUserActionSubmit(false)

            enqueueSnackbar(
                t('shipmentRefetchInSeconds', {
                    templateName,
                    seconds: REFETCH_DELAY_SECONDS,
                }),
                { variant: 'info' },
            )

            if (refetchTimeoutRef.current) {
                clearTimeout(refetchTimeoutRef.current)
            }

            refetchTimeoutRef.current = setTimeout(() => {
                refetch()
                refetchTimeoutRef.current = null
            }, REFETCH_DELAY_MS)
        } catch {
            dispatch(updateLoader(false))
            enqueueSnackbar(t('anErrorOccurred'), { variant: 'error' })
        }
    }, [
        dispatch,
        viewID,
        userActionValue,
        orgId,
        enqueueSnackbar,
        t,
        refetch,
        templateName,
    ])

    const onCloseUserActionsSubmit = () => {
        setUserActionValue('')
        setIsOpenUserActionSubmit(false)
    }
    //Relation modification functions
    const onClickRelationPreview = (item: any) => {
        if (item) {
            const updatedParams = new URLSearchParams(searchParams.toString())
            updatedParams.set(URLSearchParamsKeys.instanceId, item.entityId)
            updatedParams.set(URLSearchParamsKeys.templateId, item.templateId)
            setSearchParams(updatedParams)
        }
    }

    const onClickDeleteRelationItemAndOpenConfirmation = (rel: any) => {
        setIsOpenDeleteConfirmForRelationEntity(true)
        setDeletingRelationItem(rel)
    }

    const onSubmitDeleteRelationItemAndOpenConfirmation = async (
        status: any,
        replacedItem: any,
    ) => {
        const payload = {
            parentInstanceId: viewID,
            childInstanceId: deletingRelationItem?.entityId,
            newChildInstanceId: replacedItem ? replacedItem.entityId : '',
            relationStatus: status,
        }
        dispatch(updateLoader(true))
        await modifingItemInRelation(orgId, payload)
        refetch()
        dispatch(updateLoader(false))
    }

    const onCloseDeleteRelationItemAndOpenConfirmation = () => {
        setIsOpenDeleteConfirmForRelationEntity(false)
        setDeletingRelationItem(null)
    }

    useEffect(() => {
        return () => {
            if (refetchTimeoutRef.current) {
                clearTimeout(refetchTimeoutRef.current)
                refetchTimeoutRef.current = null
            }
        }
    }, [])

    return (
        <Box>
            <Box
                display="flex"
                alignItems="center"
                // justifyContent="space-between"
                sx={{
                    background: '#DCECF9',
                    padding: '9px 10px',
                    borderRadius: '5px 5px 0px 0px',
                }}
            >
                <Box display="flex" alignItems="center" height="40px">
                    <Typography variant="h6">{t('details')}</Typography>
                    {/* UBQ-5027: completed (archived) devices are read-only —
                        hide the edit action in the Device Manager preview. */}
                    {(isSuperAdmin || hasEditPermission) &&
                        !(
                            isDeviceManagerApp && isCompletedDevice({ status })
                        ) && (
                            <IconButton
                                id="edit-preview-button"
                                onClick={onClickEditIcon}
                                aria-controls="simple-menu-preview"
                                aria-haspopup="true"
                                key="edit-preview"
                            >
                                <img
                                    src="/assets/images/icons/edit.svg"
                                    alt="Edit"
                                />
                            </IconButton>
                        )}
                </Box>
                <Box marginLeft="auto" marginRight={'10px'}>
                    <PreviewColumnsArrangement />
                </Box>
                <Box>
                    {userActionsData?.length > 0 && hasEditPermission && (
                        <ActionsDropdown
                            availableActions={userActionsData}
                            onClickUserActions={onClickUserActions}
                            userActionValue={userActionValue}
                        />
                    )}
                </Box>
            </Box>
            <Box
                display="flex"
                sx={{
                    background: '#F5FBFF',
                }}
                padding="5px 10px"
            >
                <Box sx={{ width: '100%' }}>
                    <List>
                        {detailsAttributes?.map((item: any, index: number) => {
                            let textValue

                            switch (true) {
                                case item.id === 'entityStatus': {
                                    let statusLabel: string
                                    if (
                                        isDeviceManagerApp &&
                                        status === EntityStatus.ACTIVE
                                    ) {
                                        const hasActiveRelation =
                                            entityParentRelationsData?.some(
                                                (rel: any) =>
                                                    rel.status === 'ACTIVE',
                                            )
                                        statusLabel = hasActiveRelation
                                            ? DeviceManagerStatusToUI[
                                                  EntityStatus.ACTIVE
                                              ]
                                            : DeviceManagerStatusToUI[
                                                  DEVICE_MANAGER_REGISTERED
                                              ]
                                    } else {
                                        statusLabel =
                                            EntityStatusBEtoUI[
                                                status as keyof typeof EntityStatusBEtoUI
                                            ] || status
                                    }
                                    textValue = (
                                        <TruncatedText text={t(statusLabel)} />
                                    )
                                    break
                                }
                                case isGeoFence(item) || isGPS(item):
                                    textValue = (
                                        <GeoJSONTypeData
                                            fontSize="14px"
                                            index={index}
                                            dataValue={item?.value}
                                            item={item}
                                        />
                                    )
                                    break
                                case isURL(item):
                                    textValue = (
                                        <URLTypeData dataValue={item.value} />
                                    )
                                    break
                                case isPDFBase64(item):
                                    textValue = (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <CertificateViewer
                                                pdfBase64={item.value}
                                            />
                                        </Box>
                                    )
                                    break
                                case isEntity(item) || isEntityJson(item):
                                    textValue = (
                                        <EntityTypeData
                                            fontSize="14px"
                                            dataValue={item?.value}
                                            orgId={orgId}
                                        />
                                    )
                                    break
                                case isJson(item): {
                                    const temp = {
                                        header: item.columnName,
                                        accessorKey: item.name,
                                        dataType: item.dataType,
                                    }
                                    textValue = (
                                        <EntityJsonTypeData
                                            fontSize="14px"
                                            item={temp}
                                            dataValue={item.value}
                                        />
                                    )
                                    break
                                }
                                case !!isFile(item):
                                    textValue = (
                                        <EntityFileTypeData
                                            dataValue={item?.value}
                                            item={item}
                                        />
                                    )
                                    break
                                case isDateTime(item) &&
                                    isAttributeTypeStatic(item):
                                    textValue = (
                                        <DatetimeTypeData
                                            dataValue={item?.value}
                                        />
                                    )
                                    break
                                case (isDateTime(item) &&
                                    !isAttributeTypeStatic(item)) ||
                                    isCreationDateTime(item):
                                    textValue = (
                                        <DatetimeTypeData
                                            dataValue={item?.value}
                                            showTimezone={false}
                                        />
                                    )
                                    break
                                case isAlaramSatus(item):
                                    textValue = (
                                        <AlarmStatusTypeData
                                            value={item?.value}
                                            shouldUpdateTab={isColdChainView}
                                        />
                                    )
                                    break
                                default: {
                                    textValue = (
                                        <EntityTableCell
                                            fontSize="14px"
                                            dataValue={item.value}
                                            item={item}
                                            showUnits={true}
                                        />
                                    )
                                }
                            }

                            return item?.metadata?.Hidden ||
                                (item?.metadata?.Superviewer &&
                                    !isSuperAdmin) ? (
                                <> </>
                            ) : (
                                <ViewEntityBox
                                    key={index + item.name}
                                    index={index}
                                    name={item.name}
                                    textValue={textValue}
                                />
                            )
                        })}

                        <ListItem
                            sx={{
                                alignItems: 'flex-start',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                            }}
                        >
                            <BusinessRuleSetsView rulesets={ruleSets} />
                        </ListItem>

                        {!isColdChainView &&
                            !isFacilityMonitoringView &&
                            entityParentRelationsData?.map((item: any) => (
                                <ViewEntityRow
                                    label={t('parentEntity')}
                                    key={item.uid}
                                >
                                    <Box
                                        sx={
                                            hasEditPermission
                                                ? {
                                                      background: '#DCECF9',
                                                      padding: '2px 10px',
                                                      borderRadius: '5px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      maxWidth: '100%',
                                                  }
                                                : {}
                                        }
                                    >
                                        <Box
                                            id={`parent-relation-preview-${item.uid}`}
                                            onClick={() => {
                                                if (hasEditPermission) {
                                                    onClickRelationPreview(item)
                                                }
                                            }}
                                            sx={{
                                                cursor: hasEditPermission
                                                    ? 'pointer'
                                                    : '',
                                                width: `${item.uid ? 'calc(100%)' : '50px'}`,
                                                height: `${item.uid ? 'auto' : '20px'}`,
                                            }}
                                        >
                                            <TruncatedText
                                                sx={{
                                                    fontSize: '14px',
                                                    color: hasEditPermission
                                                        ? '#6d6dff'
                                                        : '',
                                                }}
                                                text={item.uid}
                                            />
                                        </Box>
                                    </Box>
                                </ViewEntityRow>
                            ))}

                        {!isColdChainView &&
                            entityRelationsData?.map((item: any) => (
                                <ViewEntityRow
                                    key={item.uid}
                                    label={t(item.name)}
                                >
                                    <Box
                                        sx={
                                            hasChildRelationEditPermission
                                                ? {
                                                      background: '#DCECF9',
                                                      padding:
                                                          '2px 5px 2px 10px',
                                                      paddingRight: '5px',
                                                      borderRadius: '5px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      maxWidth: '100%',
                                                  }
                                                : {}
                                        }
                                    >
                                        <Box
                                            id={`child-relation-preview-${item.uid}`}
                                            onClick={() => {
                                                if (
                                                    hasChildRelationEditPermission
                                                ) {
                                                    onClickRelationPreview(item)
                                                }
                                            }}
                                            sx={{
                                                cursor: hasChildRelationEditPermission
                                                    ? 'pointer'
                                                    : '',
                                                width: hasChildRelationEditPermission
                                                    ? 'calc(100% - 22px)'
                                                    : 'cacl(100%)',
                                                height: hasChildRelationEditPermission
                                                    ? 'auto'
                                                    : '20px',
                                            }}
                                        >
                                            <TruncatedText
                                                sx={{
                                                    fontSize: '14px',
                                                    color: hasChildRelationEditPermission
                                                        ? '#6d6dff'
                                                        : '',
                                                }}
                                                text={item.uid}
                                            />
                                        </Box>

                                        {hasChildRelationEditPermission &&
                                            (item.status === 'ACTIVE' ? (
                                                <Box
                                                    id={`delete-relation-preview-${item.uid}`}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                        marginLeft: '6px',
                                                    }}
                                                    onClick={() =>
                                                        onClickDeleteRelationItemAndOpenConfirmation(
                                                            item,
                                                        )
                                                    }
                                                >
                                                    <IconButton
                                                        sx={{
                                                            padding: '0px',
                                                        }}
                                                    >
                                                        <CloseOutlined
                                                            sx={{
                                                                color: '#747474',
                                                                fontSize:
                                                                    '17px',
                                                            }}
                                                        />
                                                    </IconButton>
                                                </Box>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                        marginLeft: '6px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <Tooltip
                                                        title={t(
                                                            'relationStatus',
                                                            {
                                                                status: item.status?.toLowerCase(),
                                                            },
                                                        )}
                                                        placement="top"
                                                    >
                                                        <Info
                                                            sx={{
                                                                color: '#747474',
                                                                fontSize:
                                                                    '20px',
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                            ))}
                                    </Box>
                                </ViewEntityRow>
                            ))}
                    </List>
                </Box>
            </Box>
            <ConfirmationDialog
                openDialog={isOpenUserActionSubmit}
                handleComfirm={() => onSubmitUserActions()}
                handleClose={() => onCloseUserActionsSubmit()}
                DialogHeaderText={t('confirmAction')}
                DialogBodyText={
                    <Typography>
                        {t('doYouWantTo')} <b>{userActionValue}</b>{' '}
                        {templateName} ?
                    </Typography>
                }
                confirmtext={t('confirm')}
                cancelText={t('cancel')}
            />
            <RelationModification
                orgId={orgId}
                parentTemplateId={entityTemplateId}
                selectedItemTemplateId={deletingRelationItem?.templateId}
                isOpen={isOpenDeleteConfirmForRelationEntity}
                onClose={onCloseDeleteRelationItemAndOpenConfirmation}
                onSubmit={onSubmitDeleteRelationItemAndOpenConfirmation}
            />
            {openEntityInstance && (
                <EntityInstance
                    isEdit={true}
                    handleCloseFields={handleCloseFields}
                    entityData={viewEntityData}
                    instanceType={
                        isColdChainView
                            ? EntityInstanceTypes.IN_TRANSIT
                            : EntityInstanceTypes.NORMAL
                    }
                />
            )}
        </Box>
    )
}

export default DetailsView
